import { render, staticRenderFns } from "./ButtonNavigation.vue?vue&type=template&id=7713b01c&scoped=true&lang=pug&"
import script from "./ButtonNavigation.vue?vue&type=script&lang=ts&"
export * from "./ButtonNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonNavigation.vue?vue&type=style&index=0&id=7713b01c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7713b01c",
  null
  
)

export default component.exports